import './dialog.scss';
import { useCallback, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Dialog = ({ isOpen, onClose, children, additionnalStyles = '', closeDisabled = false, closeLabel = 'Close', labelledBy, onElement }) => {
    const dialogRef = useRef(null);
    const attachDialog = useCallback((element) => {
        dialogRef.current = element;
        onElement?.(element);
    }, [onElement]);

    useEffect(() => {
        if (isOpen && dialogRef.current) {
            dialogRef.current.showModal();
        } else if (dialogRef.current) {
            dialogRef.current.close();
        }
    }, [isOpen]);

    useEffect(() => {
        const handleCancel = (e) => {
            e.preventDefault();
            if (!closeDisabled) onClose?.();
        };
        const dialogEl = dialogRef.current;
        if (dialogEl) {
            dialogEl.addEventListener('cancel', handleCancel);
        }
        return () => {
            if (dialogEl) {
                dialogEl.removeEventListener('cancel', handleCancel);
            }
        };
    }, [onClose, closeDisabled]);

    return (
        <dialog ref={attachDialog} className={`dialog ${additionnalStyles}`} data-testid="dialog" aria-labelledby={labelledBy}>
            <div className='dialog-content' data-testid="dialog-content">
                {onClose && <button type='button' className='dialog-close' onClick={onClose} disabled={closeDisabled} aria-label={closeLabel} data-testid="dialog-close-button">
                    <FontAwesomeIcon icon={faTimes} />
                </button>}
                {children}
            </div>
        </dialog>
    );
};

export default Dialog;
